'use client';
import { useTranslation } from '@/i18n/client';
import CDNImage from '@/components/cdnImage/cdnImage';
import { Button } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import JDIPrice from '@/components/price/index';
import type { LocalInfoType } from '@/apis/common.types';

import styles from './index.module.scss';
interface Detail {
  titleText: string;
  price: string;
  priceColor: string;
  sign?: string;
  plusIconUrl?: string;
}
interface Props {
  hintText: string;
  summaryText: string;
  summaryPrice: string;
  detailList: Detail[];
  symbol: string;
  popupTitle: string;
  localInfo: LocalInfoType;
  // onConfirm?:()=> {}
}

// const ConfirmButton = muiStyled(Button)(() => ({
//   color: "#fff",
//   backgroundColor: "#CC0C1C",
//   lineHeight: "28px",
//   padding: "0 8px",
//   minWidth: "auto",
//   "&:hover": {
//     borderColor: "#990915",
//     backgroundColor: "#990915",
//     boxShadow: "none",
//   }
// }));

export default function FinalPriceDrawerContent({
  summaryText,
  summaryPrice,
  detailList,
  // symbol,
  hintText,
  popupTitle,
  localInfo,
  // onConfirm
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.finalPriceDrawer}>
      <div className={styles.title}>{popupTitle}</div>
      <div className={styles.detailItemList}>
        {detailList?.map((item: Detail, index) => {
          return (
            <div className={styles.detailItem} key={`final-detail-${index}`}>
              <span>
                {item.titleText}
                {/* {item?.plusIconUrl && (
                  <CDNImage
                    className={styles.iconPlus}
                    src={item.plusIconUrl}
                    width={28}
                    height={14}
                    alt='plus'
                  />
                )} */}
              </span>
              <span style={{ color: item?.priceColor }}>
                {item?.sign || ''}
                {/* {symbol || ''} */}
                {/* {item.price} */}
                <JDIPrice
                  locale={localInfo?.languageCode}
                  currency={localInfo?.currency}
                  price={item.price}
                  containerStyle={{
                    fontSize: '14px',
                    lineHeight: '34px',
                    color: item?.priceColor,
                    fontWeight: 400,
                  }}
                  integerStyle={{
                    fontSize: '14px',
                    lineHeight: '34px',
                    color: item?.priceColor,
                    fontWeight: 400,
                  }}
                />
              </span>
            </div>
          );
        })}
      </div>
      <div className={styles.summary}>
        <span dangerouslySetInnerHTML={{ __html: summaryText }}></span>
        <span>
          {/* {symbol} */}
          {/* {summaryPrice} */}
          <JDIPrice
            locale={localInfo?.languageCode}
            currency={localInfo?.currency}
            price={summaryPrice}
            containerStyle={{
              fontSize: '18px',
              lineHeight: '48px',
              fontWeight: 400,
            }}
            integerStyle={{
              fontSize: '18px',
              lineHeight: '48px',
              fontWeight: 400,
            }}
          />
        </span>
      </div>
      <div className={styles.hint}>{hintText}</div>
      {/* <div className={styles.btnWrap}>
        <ConfirmButton onClick={onConfirm}>OK</ConfirmButton>
      </div> */}
    </div>
  );
}
